import React, { useRef, useEffect, useState } from "react";
import lock from "../../../assets/logos/icons-lock.png";
import unlock from "../../../assets/logos/icons-unlock.png";
import p5 from "p5";

let validation = { activeOnSubit: false };

export default function P5Contianer({
  tFunction,
  widthImg,
  heightImg,
  base64Img,
  imgSignature,
  widthImgSignature,
  heightImgSignature,
  save,
  activeOnSubit,
  back,
  isAndroid,
  gotToEnd,
  isPhone,
  signatures,
  currentPage,
  xCoordinates,
  yCoordinates,
  disable
}) {
  if (activeOnSubit !== validation.activeOnSubit) {
    validation.activeOnSubit = activeOnSubit;
  }
  const p5Ref = useRef();
  const [p5Canvas, setp5Canvas] = useState(null);
  const Sketch = (sketch) => {
    let page = null;
    let isSubmit = false;
    let cancelBtn;
    // let backBtn;
    let singBtn;
    let wRect = widthImgSignature / 3;
    let hRect = heightImgSignature / 3;
    let xRect = xCoordinates ? xCoordinates : (widthImg * 0.55);
    let yRect = yCoordinates ? heightImg - yCoordinates - hRect : heightImg * 0.75;
    let signature = null;
    let isActiveCircleTopLeft = false;
    let isActiveCircleBottomLeft = false;
    let isActiveCircleTopRight = false;
    let overImage = false;
    let locked = false;
    let xOffSet = 0;
    let yOffSet = 0;
    let done = false;
    let lockImg = null;
    let unlockImg = null;
    let isLock = false;
    let savePostion = {};
    sketch.preload = () => {
      page = sketch.loadImage(base64Img);
      signature = sketch.loadImage(imgSignature);
      lockImg = sketch.loadImage(lock);
      unlockImg = sketch.loadImage(unlock);
    };
    sketch.setup = () => {
      sketch.createCanvas(widthImg, heightImg + 70);
      sketch.textSize(15);
      sketch.noStroke();
      sketch.textSize(15);
      sketch.noStroke();
      singBtn = sketch.createButton(tFunction("requestReliableSignature.save"));
      cancelBtn = sketch.createButton(tFunction("requestReliableSignature.backLaber"));
      if (widthImg < 550) {
        cancelBtn.position(
          widthImg / 2 - 47.5 - 32 - 95 - 10 + 100,
          heightImg + 70 + (isPhone ? 200 : 100)
        );
        singBtn.position(
          widthImg / 2 - 47.5 + 16 + 95 + 50 + 50,
          heightImg + 70 + (isPhone ? 200 : 100)
        );
      } else {
        cancelBtn.position(
          widthImg / 2 - 47.5 - 32 + 200 - 10,
          heightImg + 90 + (isPhone ? 200 : 75)
        );
        singBtn.position(
          widthImg / 2 - 47.5 + 16 + 299 + 50,
          heightImg + 90 + (isPhone ? 200 : 75)
        );
      }
      singBtn.mouseClicked(() => {
        let data = {
          x: xRect,
          y: yRect,
          width: wRect,
          height: hRect,
          savePostion,
        };
        data.y = heightImg - data.y - data.height;
        // data.y = data.y + 10
        // data.x = data.x - 19
        save(data);
      });
      singBtn.class("canvasBtn");
      cancelBtn.class("buttonHLPure-secondary");
      cancelBtn.mouseClicked(() => {
        back();
      });
    };
    sketch.draw = () => {
      let widthRect = wRect;
      let heightRect = hRect;
      let initX = xRect;
      let initY = yRect;
      let xCircle = xRect + wRect;
      let yCircle = yRect + hRect;
      sketch.background(220);
      sketch.fill("#005DA1");
      sketch.rect(0, 0, widthImg + 2, heightImg + 2);
      sketch.fill(255);
      sketch.image(page, 1, 2, widthImg - 2, heightImg - 2);

      if (isActiveCircleTopLeft) {
        initX = sketch.mouseX;
        initY = sketch.mouseY;
        widthRect = widthRect + xRect - sketch.mouseX;
        heightRect = heightRect + yRect - sketch.mouseY;
      }
      if (isActiveCircleTopRight) {
        widthRect = sketch.mouseX - xRect;
        initY = sketch.mouseY;
        heightRect = heightRect + yRect - sketch.mouseY;
      }
      if (isActiveCircleBottomLeft) {
        initX = sketch.mouseX;
        widthRect = widthRect + xRect - sketch.mouseX;
        heightRect = sketch.mouseY - yRect;
      }
      if (
        sketch.mouseX >= initX + 5 &&
        sketch.mouseX <= initX + widthRect - 5 &&
        sketch.mouseY >= initY + 5 &&
        sketch.mouseY <= initY + heightRect - 5
      ) {
        let isCurrent = false;
        isCurrent = overImage || isCurrent;
        if (!isCurrent && !done) overImage = true;
      } else overImage = false;

      sketch.image(signature, initX, initY, widthRect, heightRect);
      savePostion = { signature, initX, initY, widthRect, heightRect };
      if (signatures) {
        for (let i = 0; i < signatures.length; i++) {
          const item = signatures[i];
          const { savePostion } = item;
          if (savePostion && item.page === currentPage) {
            sketch.image(
              savePostion.signature,
              savePostion.initX,
              savePostion.initY,
              savePostion.widthRect,
              savePostion.heightRect
            );
          }
        }
      }
      if (validation.activeOnSubit) {
        isSubmit = true;
      }
      if (validation.activeOnSubit && isSubmit) {
        isSubmit = false;
      }
      sketch.fill(80, 105, 14);
      sketch.stroke("#005DA1");
      sketch.rect(initX, initY, widthRect, 0.5);
      sketch.rect(initX, initY, 0.5, heightRect);
      sketch.rect(initX + widthRect, initY, 0.5, heightRect);
      sketch.rect(initX, initY + heightRect, widthRect, 0.5);
      sketch.fill(255, 255, 255);
      sketch.stroke("#fff");
      sketch.rect(0, heightImg + 2, widthImg, 100);
      sketch.fill(0, 0, 0);
      xCircle = sketch.mouseX;
      yCircle = sketch.mouseY;
      if (isAndroid) {
        sketch.image(
          isLock ? lockImg : unlockImg,
          initX + widthRect * 0.9 - 13,
          initY + 5,
          26,
          26
        );
      }
    };

    sketch.mousePressed = () => {
      if (isAndroid) {
        if (
          xRect + wRect * 0.9 - 13 <= sketch.mouseX &&
          xRect + wRect * 0.9 + 13 >= sketch.mouseX &&
          yRect + 44 >= sketch.mouseY &&
          yRect + 5 <= sketch.mouseY
        ) {
          isLock = !isLock;
        } else if (!isLock) {
          xRect = sketch.mouseX - wRect / 2;
          yRect = sketch.mouseY - hRect / 2;
        }
      } else {
        if (overImage) {
          locked = disable ? false : true;
        } else {
          locked = false;
        }
        xOffSet = sketch.mouseX - xRect;
        yOffSet = sketch.mouseY - yRect;
      }
    };

    sketch.mouseDragged = () => {
      if (locked) {
        xRect = sketch.mouseX - Math.floor(xOffSet);
        yRect = sketch.mouseY - Math.floor(yOffSet);
      }
    };

    sketch.mouseReleased = () => {
      locked = false;
    };
  };
  useEffect(() => {
    setp5Canvas(new p5(Sketch, p5Ref.current));
    setTimeout(() => {
      gotToEnd();
    }, 100);
  }, []);

  return <div className="p5Container" ref={p5Ref} />;
}
